import Config from "../../Config";
import { fetchUtils } from "react-admin";
import { AccessRestriction } from "./Media.enum";

const apiUrl = Config.API_URL;
const httpClient = (url: string, options: any = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  const access_token = localStorage.getItem("access_token");
  options.headers.set("Authorization", `Bearer ${access_token}`);
  return fetchUtils.fetchJson(url, options);
};
const MediaDataProvider = {
  // getSeason: async (mediaList: any[]) => {
  //   for (const element of mediaList) {
  //     for (const webzone of element.media.webzones) {
  //       if (webzone.type === WebzoneType.SEASON) {
  //         element.seasonName = webzone.name;
  //       }
  //     }
  //   }
  //   return mediaList;
  // },

  getMediasBanner: async (mediaList: any[]) => {
    for (const element of mediaList) {
      try {
        let url =
          apiUrl + "/media/" + element.media.id + "/banner_vignette/url";
        let { body } = await httpClient(url);
        element.banner = body;
      } catch (error) {
        console.log("ERROR", error);
        element.banner = null;
      }
    }
    return mediaList;
  },

  getMediaContent: async (
    resource: string,
    json: {
      media: {
        id: string;
        /*tags: any;*/ tagIds: string[];
        /*webzones: any;*/ webzoneIds: string[];
        accessRestriction: AccessRestriction;
      };
      banner: string | null;
      home_banner: string | null;
      pictures_input: { url: any; desc: any }[];
      video_url: string | null;
      srt_url: string | null;
    }
  ) => {
    try {
      // GET BANNERS
      let url = apiUrl + "/media/" + json.media.id + "/banner_vignette/url";
      let { body } = await httpClient(url);
      json.banner = body === "default" ? null : body;
      url = apiUrl + "/media/" + json.media.id + "/home_banner_vignette/url";
      ({ body } = await httpClient(url));
      json.home_banner = body === "default" ? null : body;
      if (resource === "Gallery") {
        // GET PICTURES
        url = apiUrl + "/picture/of_gallery/" + json.media.id;
        const gallery_pictures = await httpClient(url);
        json.pictures_input = [];
        for (const picture of gallery_pictures.json) {
          json.pictures_input.push({
            url: picture.url_vignette,
            desc: picture.id,
          });
        }
      } else if (resource === "Video") {
        //TODO: Mettre la bonne route
        url = `${apiUrl}/video/${json.media.id}/url`;
        ({ body } = await httpClient(url));
        json.video_url = body;
        url = `${apiUrl}/video/${json.media.id}/srturl`;
        ({ body } = await httpClient(url));
        json.srt_url = body;
      } else if (resource === "Vod") {
        url = `${apiUrl}/vod/${json.media.id}/url`;
        ({ body } = await httpClient(url));
        json.video_url = body;
        url = `${apiUrl}/vod/${json.media.id}/srturl`;
        ({ body } = await httpClient(url));
        json.srt_url = body;
      }
    } catch (error) {
      console.log("ERROR", error);
      json.banner = null;
      json.home_banner = null;
    }
    return json;
  },

  updateMedia: async (
    resource: string,
    params: {
      data: {
        media: {
          id: any;
          tagIds: string[];
          webzoneIds: any;
          accessRestriction: AccessRestriction;
        };
        video_input: { rawFile: string | Blob };
        srt_input: { rawFile: string | Blob };
        pictures: any[];
        pictures_input: any[];
        banner_update: { rawFile: string | Blob };
        home_banner_update: { rawFile: string | Blob };
        purchasePrice?: number;
        youtubeUrl?: string;
      };
      previousData: {
        media: { accessRestriction: AccessRestriction };
      };
      id: any;
    }
  ) => {
    // UPDATE MEDIA
    // SET VOD price
    let body;
    if (resource === "Vod") {
      body = {
        ...params.data.media,
        purchasePrice: params.data.purchasePrice,
      };
    } else if (resource === "Video") {
      body = {
        ...params.data.media,
        youtubeUrl: params.data.youtubeUrl,
      };
    } 
    
    else {
      body = { ...params.data.media };
    }

    // console.log("updateMedia", params);
    const url = `${apiUrl}/${resource}/${params.data.media.id}`;
    await httpClient(url, {
      method: "PATCH",
      body: JSON.stringify(body),
    });

    // MOVE S3 content if access restriction change
    if (
      resource === "Video" &&
      params.data.media.accessRestriction !==
        params.previousData.media.accessRestriction
    ) {
      // console.log(
      //   "Access restriction change to",
      //   params.data.media.accessRestriction
      // );
      const body = {
        isPrivate:
          params.data.media.accessRestriction ===
          AccessRestriction.MEMBER_PREMIUM,
      };
      const url = `${apiUrl}/${resource}/${params.data.media.id}/move`;
      await httpClient(url, {
        method: "PATCH",
        body: JSON.stringify(body),
      });
    }

    //UPDATE VIDEO
    if ((resource === "Video" || resource === "Vod") && params.data.video_input === null) {
      const url = `${apiUrl}/${resource}/${params.data.media.id}/deleteVideo`;
      console.log("DELETE", url);
      await httpClient(url, {
        method: "DELETE",
      });
      // } else if (resource === "Video" && params.data.video_input) {
      //   console.log("BEFORE UPLOAD VIDEO");
      //   const url = `${apiUrl}/${resource}/${params.data.media.id}/uploadVideo`;
      //   const formData = new FormData();
      //   formData.append("file", params.data.video_input.rawFile);
      //   const toto = await httpClient(url, {
      //     method: "POST",
      //     body: formData,
      //   });
      //   console.log("AFTER UPLOAD VIDEO", toto);
    }
    if ((resource === "Video" || resource === "Vod") && params.data.srt_input === null) {
      const url = `${apiUrl}/${resource}/${params.data.media.id}/deleteSrt`;
      console.log("DELETE", url);
      await httpClient(url, {
        method: "DELETE",
      });
    } else if ((resource === "Video" || resource === "Vod") && params.data.srt_input) {
      const url = `${apiUrl}/${resource}/${params.data.media.id}/uploadSrt`;
      const formData = new FormData();
      formData.append("file", params.data.srt_input.rawFile);
      await httpClient(url, {
        method: "POST",
        body: formData,
      });
    }
    //UPDATE GALLERY
    if (resource === "Gallery") {
      const previous_pictures = params.data.pictures
        ? params.data.pictures.map((x: any) => x.id)
        : [];
      const current_pictures = params.data.pictures_input
        ? params.data.pictures_input
            .map((x: any) => x.desc)
            .filter((x: any) => x != null)
        : [];
      const to_create_pictures = params.data.pictures_input
        ? params.data.pictures_input /*.map((x: any) => x.new_picture)*/
            .filter((x: any) => x.new_picture != null)
        : [];
      // console.log(previous_pictures);
      // console.log(current_pictures);
      // console.log(to_create_pictures);
      for (const picture of previous_pictures) {
        if (
          !current_pictures.includes(picture) ||
          to_create_pictures
            .map((x: any) => x.desc)
            .filter((x: any) => x != null)
            .includes(picture)
        ) {
          // console.log("remove picture", picture);
          const url = `${apiUrl}/picture/${picture}`;
          await httpClient(url, {
            method: "DELETE",
          });
        }
      }
      const url = `${apiUrl}/${resource}/${params.data.media.id}/uploadPicture`;
      for (const picture of to_create_pictures) {
        const formData = new FormData();
        formData.append("file", picture.new_picture.rawFile);
        const result = await httpClient(url, {
          method: "POST",
          body: formData,
        });
        const idx = current_pictures.indexOf(picture.desc);
        if (idx > -1) {
          current_pictures[idx] = result.json.id;
        } else {
          current_pictures.push(result.json.id);
        }
        // console.log(result);
      }
      if (current_pictures.length > 0) {
        const urlReorder = `${apiUrl}/picture/reorder_gallery/${params.data.media.id}`;
        await httpClient(urlReorder, {
          method: "PATCH",
          body: JSON.stringify({ picture_ids: current_pictures }),
        });
      }
    }
    // UPDATE BANNERS
    if (params.data.banner_update === null) {
      const url = `${apiUrl}/Media/${params.data.media.id}/remove/banner`;
      await httpClient(url, {
        method: "DELETE",
      });
    } else if (params.data.banner_update) {
      const url = `${apiUrl}/Media/${params.id}/upload/banner`;
      const formData = new FormData();
      formData.append("file", params.data.banner_update.rawFile);

      await httpClient(url, {
        method: "POST",
        body: formData,
      });
    }
    if (params.data.home_banner_update === null) {
      const url = `${apiUrl}/Media/${params.data.media.id}/remove/home_banner`;
      await httpClient(url, {
        method: "DELETE",
      });
    } else if (params.data.home_banner_update) {
      const url = `${apiUrl}/Media/${params.id}/upload/home_banner`;
      const formData = new FormData();
      formData.append("file", params.data.home_banner_update.rawFile);

      await httpClient(url, {
        method: "POST",
        body: formData,
      });
    }
  },

  createMedia: async (
    resource: string,
    params: {
      data: {
        media: any;
        video_input: { rawFile: string | Blob };
        srt_input: { rawFile: string | Blob };
        pictures_input: any;
        banner: { rawFile: string | Blob };
        home_banner: { rawFile: string | Blob };
        purchasePrice?: number;
      };
    }
  ): Promise<any> => {
    console.log("params.data", params.data);
    // SET VOD price
    if (resource === "Vod") {
      params.data.media.purchasePrice = params.data.purchasePrice;
    }
    const { json } = await httpClient(`${apiUrl}/${resource}`, {
      method: "POST",
      body: JSON.stringify(params.data.media),
    });
    if (resource === "Video" && params.data.srt_input) {
      const url = `${apiUrl}/${resource}/${json.id}/uploadSrt`;
      const formData = new FormData();
      formData.append("file", params.data.srt_input.rawFile);
      await httpClient(url, {
        method: "POST",
        body: formData,
      });
    }
    if (resource === "Gallery" && params.data.pictures_input) {
      const url = `${apiUrl}/${resource}/${json.id}/uploadPicture`;
      for (const picture of params.data.pictures_input) {
        const formData = new FormData();
        formData.append("file", picture.rawFile);
        await httpClient(url, {
          method: "POST",
          body: formData,
        });
      }
    }
    if (params.data.banner) {
      const url = `${apiUrl}/Media/${json.id}/upload/banner`;
      const formData = new FormData();
      formData.append("file", params.data.banner.rawFile);

      await httpClient(url, {
        method: "POST",
        body: formData,
      });
    }
    if (params.data.home_banner) {
      const url = `${apiUrl}/Media/${json.id}/upload/home_banner`;
      const formData = new FormData();
      formData.append("file", params.data.home_banner.rawFile);

      await httpClient(url, {
        method: "POST",
        body: formData,
      });
    }

    return json;
  },
};

export default MediaDataProvider;
